// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_containerTitle__hS\\+x- {
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: 1.5rem;
}

.styles_containerButtons__QBhuM {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.styles_title__4Zbw\\+ {
  color: #18316e;
  font-size: 1.5rem;
  font-weight: bold;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0;
}

.styles_containerVersao__Nn-iR {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.styles_itemVersao__MLAKK {
  align-items: center;
  border-radius: 5px;
  box-shadow: 1px 1px 5px #c6c6c6;
  display: flex;
  justify-content: space-between;
  padding: 0.75rem 0.9rem;
  background: #fff;
  flex-direction: column;
  gap: 0.75rem;
}

.styles_itemHeader__2LtRd {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.styles_itemHeader__2LtRd > span {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.styles_itemDate__eJ4bg {
  font-size: 0.8rem;
  color: #a4a4a4;
  margin: 0;
}

.styles_containerBtn__yamoo {
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-top: 1.5rem;
  gap: 0.5rem;
}

.styles_btnAnalisar__VbqS0 {
  background: #18316e !important;
}

.styles_btnAnalisar__VbqS0:hover {
  background: #204091 !important;
}

.styles_btnAnalisar__VbqS0:disabled {
  background: #18316e !important;
  color: #ffffff !important;
  opacity: 0.5 !important;
}

.styles_btnFechar__LDqEw {
  border-color: #18316e !important;
  color: #18316e !important;
}

.styles_btnProjeto__h3Kag {
  background: #fff !important;
  color: #18316e !important;
  border-color: #18316e !important;
}

.styles_btnProjeto__h3Kag:hover {
  background: #f5f5f5 !important;
  border-color: #204091 !important;
  color: #204091 !important;
}

.styles_btnProjeto__h3Kag:disabled {
  background: #fff !important;
  color: #a4a4a4 !important;
  border-color: #a4a4a4 !important;
  opacity: 0.6 !important;
}

.styles_motoresContainer__w\\+ZP4 {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.5rem;
}

.styles_motoresLeft__8YMEZ {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.styles_btnMotor__IWRfa {
  background: #18316e !important;
}

.styles_btnMotor__IWRfa:hover {
  background: #204091 !important;
}

.styles_btnMotorRight__c0AGH {
  background: #18316e !important;
}

.styles_btnMotorRight__c0AGH:hover {
  background: #204091 !important;
}

/* Botões sem tema disponível */
.styles_btnMotor__IWRfa.styles_btnSemTema__37skR,
.styles_btnMotorRight__c0AGH.styles_btnSemTema__37skR {
  background: #a4a4a4 !important;
  color: #ffffff !important;
  cursor: not-allowed !important;
}

.styles_btnMotor__IWRfa.styles_btnSemTema__37skR:hover,
.styles_btnMotorRight__c0AGH.styles_btnSemTema__37skR:hover {
  background: #a4a4a4 !important;
}

.styles_containerProgresso__M3pPp {
  margin-top: 0.5rem;
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
}

.styles_containerProgresso__M3pPp .MuiCard-root {
  position: relative !important;
  bottom: auto !important;
  left: auto !important;
  width: 100% !important;
  min-width: auto !important;
  max-width: 100% !important;
  margin: 0 !important;
  height: auto !important;
  min-height: auto !important;
  border-radius: 5px !important;
  box-shadow: 1px 1px 5px #c6c6c6 !important;
}

.styles_containerAdicionar__Zy0UI {
  margin-bottom: 1.5rem;
}

.styles_areaAdicionar__458kS {
  background: #fff;
  border-radius: 5px;
  box-shadow: 1px 1px 5px #c6c6c6;
  padding: 0.75rem 0.9rem;
}

/* ✅ Indicadores de Status */
.styles_statusIndicator__XAqzh {
  display: flex;
  align-items: center;
  padding: 0.5rem;
  background: #e3f2fd;
  border-radius: 4px;
  margin-top: 0.5rem;
  font-size: 0.85rem;
  color: #1976d2;
}

.styles_statusIndicatorError__q5H8D {
  display: flex;
  align-items: center;
  padding: 0.5rem;
  background: #ffebee;
  border-radius: 4px;
  margin-top: 0.5rem;
  font-size: 0.85rem;
  color: #d32f2f;
}

.styles_statusIndicatorSuccess__RyjKP {
  display: flex;
  align-items: center;
  padding: 0.5rem;
  background: #e8f5e9;
  border-radius: 4px;
  margin-top: 0.5rem;
  font-size: 0.85rem;
  color: #2e7d32;
}

.styles_statusText__9cu-K {
  color: #1976d2;
  font-weight: 500;
}

.styles_statusTextError__leSRP {
  color: #d32f2f;
  font-weight: 500;
}

.styles_statusTextSuccess__kYs4Q {
  color: #2e7d32;
  font-weight: 500;
}

/* Indicador Aguardando */
.styles_statusIndicatorAguardando__nvT20 {
  display: flex;
  align-items: center;
  padding: 0.5rem;
  background: #fff3e0;
  border-radius: 4px;
  margin-top: 0.5rem;
  font-size: 0.85rem;
  color: #f57c00;
}

.styles_statusTextAguardando__7Sl7M {
  color: #f57c00;
  font-weight: 500;
}

/* Estilos para a vista de Projeto */
.styles_containerProjeto__AhjSP {
  margin-bottom: 1.5rem;
}

.styles_containerProjeto__AhjSP:last-child {
  margin-bottom: 0;
}

.styles_cardProjeto__YSsAG {
  background: #fff;
  border-radius: 5px;
  box-shadow: 1px 1px 5px #c6c6c6;
  padding: 1.5rem;
}

.styles_tituloProjeto__9PHG7 {
  color: #18316e;
  font-size: 1rem;
  font-weight: bold;
  margin: 0 0 1.5rem 0;
}

.styles_tabelaResumo__JIv0c {
  width: 100%;
  border-collapse: collapse;
  margin-top: 1rem;
  margin-bottom: 1.5rem;
}

.styles_tabelaResumo__JIv0c th,
.styles_tabelaResumo__JIv0c td {
  padding: 0.75rem;
  text-align: left;
  border-bottom: 1px solid #e0e0e0;
}

.styles_tabelaResumo__JIv0c th {
  background: #f5f5f5;
  font-weight: bold;
  color: #18316e;
  text-align: left;
}

.styles_tabelaResumo__JIv0c td {
  color: #333;
}

.styles_tabelaResumo__JIv0c tbody tr:hover {
  background: #f9f9f9;
}

.styles_tabelaResumo__JIv0c .styles_linhaTotal__NL3gu {
  background: #f9f9f9;
  font-weight: bold;
  border-top: 2px solid #18316e;
}

.styles_tabelaResumo__JIv0c .styles_linhaTotal__NL3gu td {
  color: #18316e;
  font-size: 1rem;
}


/* Estilos para lista de créditos */
.styles_listaCreditos__wZN55 {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-bottom: 1.5rem;
}

.styles_itemCredito__7gbMo {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem;
  background: #f9f9f9;
  border-radius: 4px;
  border-left: 3px solid #18316e;
}

.styles_labelCredito__qPd1D {
  color: #333;
  font-size: 0.95rem;
}

.styles_valorCredito__E\\+jJA {
  color: #18316e;
  font-weight: 600;
  font-size: 0.95rem;
}

.styles_itemCreditoTotal__Urhmy {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  background: #e8f4f8;
  border-radius: 4px;
  border-left: 4px solid #18316e;
  margin-top: 0.5rem;
}

.styles_labelCreditoTotal__9Blr5 {
  color: #18316e;
  font-weight: bold;
  font-size: 1.1rem;
}

.styles_valorCreditoTotal__x5jiT {
  color: #18316e;
  font-weight: bold;
  font-size: 1.2rem;
}

.styles_containerBtnProjeto__zLaRH {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}

/* Alerta de Projeto */
.styles_alertaProjeto__HzIT8 {
  display: flex;
  align-items: stretch;
  background: #fff3e0;
  border-radius: 5px;
  margin-bottom: 1.5rem;
  position: relative;
  overflow: hidden;
}

.styles_alertaTraco__5ZSR6 {
  width: 4px;
  background: #f57c00;
  flex-shrink: 0;
}

.styles_alertaConteudo__DliJg {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 1rem;
  flex: 1 1;
}

.styles_alertaIcone__4T23L {
  color: #f57c00;
  font-size: 1.5rem;
  flex-shrink: 0;
  margin-top: 0.125rem;
}

.styles_alertaTexto__5L0tK {
  color: #e65100;
  font-size: 0.9rem;
  line-height: 1.5;
  flex: 1 1;
}

/* Tag de Projeto */
.styles_tagProjeto__Wch2h {
  display: inline-block;
  background: #18316e;
  color: #fff;
  font-size: 0.75rem;
  font-weight: 600;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  margin-left: 0.5rem;
  text-transform: uppercase;
  vertical-align: middle;
}

.styles_tagStatus__cMbfY {
  color: #ffa726;
  font-weight: 500;
  text-transform: none;
}

.styles_tagStatusAprovado__4NKn5 {
  color: #66bb6a;
  font-weight: 500;
  text-transform: none;
}

.styles_tagStatusRejeitado__ZWkF- {
  color: #ef5350;
  font-weight: 500;
  text-transform: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/PisCofins/ModalVersoes/styles.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,+BAA+B;EAC/B,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA,+BAA+B;AAC/B;;EAEE,8BAA8B;EAC9B,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,qBAAqB;EACrB,sBAAsB;EACtB,0BAA0B;EAC1B,0BAA0B;EAC1B,oBAAoB;EACpB,uBAAuB;EACvB,2BAA2B;EAC3B,6BAA6B;EAC7B,0CAA0C;AAC5C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,oCAAoC;AACpC;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;;AAGA,mCAAmC;AACnC;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,SAAO;AACT;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,SAAO;AACT;;AAEA,mBAAmB;AACnB;EACE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,oBAAoB;AACtB","sourcesContent":[".containerTitle {\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 1.5rem;\n}\n\n.containerButtons {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.title {\n  color: #18316e;\n  font-size: 1.5rem;\n  font-weight: bold;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin: 0;\n}\n\n.containerVersao {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.itemVersao {\n  align-items: center;\n  border-radius: 5px;\n  box-shadow: 1px 1px 5px #c6c6c6;\n  display: flex;\n  justify-content: space-between;\n  padding: 0.75rem 0.9rem;\n  background: #fff;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.itemHeader {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.itemHeader > span {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n}\n\n.itemDate {\n  font-size: 0.8rem;\n  color: #a4a4a4;\n  margin: 0;\n}\n\n.containerBtn {\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n  margin-top: 1.5rem;\n  gap: 0.5rem;\n}\n\n.btnAnalisar {\n  background: #18316e !important;\n}\n\n.btnAnalisar:hover {\n  background: #204091 !important;\n}\n\n.btnAnalisar:disabled {\n  background: #18316e !important;\n  color: #ffffff !important;\n  opacity: 0.5 !important;\n}\n\n.btnFechar {\n  border-color: #18316e !important;\n  color: #18316e !important;\n}\n\n.btnProjeto {\n  background: #fff !important;\n  color: #18316e !important;\n  border-color: #18316e !important;\n}\n\n.btnProjeto:hover {\n  background: #f5f5f5 !important;\n  border-color: #204091 !important;\n  color: #204091 !important;\n}\n\n.btnProjeto:disabled {\n  background: #fff !important;\n  color: #a4a4a4 !important;\n  border-color: #a4a4a4 !important;\n  opacity: 0.6 !important;\n}\n\n.motoresContainer {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.motoresLeft {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n.btnMotor {\n  background: #18316e !important;\n}\n\n.btnMotor:hover {\n  background: #204091 !important;\n}\n\n.btnMotorRight {\n  background: #18316e !important;\n}\n\n.btnMotorRight:hover {\n  background: #204091 !important;\n}\n\n/* Botões sem tema disponível */\n.btnMotor.btnSemTema,\n.btnMotorRight.btnSemTema {\n  background: #a4a4a4 !important;\n  color: #ffffff !important;\n  cursor: not-allowed !important;\n}\n\n.btnMotor.btnSemTema:hover,\n.btnMotorRight.btnSemTema:hover {\n  background: #a4a4a4 !important;\n}\n\n.containerProgresso {\n  margin-top: 0.5rem;\n  position: relative;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.containerProgresso :global(.MuiCard-root) {\n  position: relative !important;\n  bottom: auto !important;\n  left: auto !important;\n  width: 100% !important;\n  min-width: auto !important;\n  max-width: 100% !important;\n  margin: 0 !important;\n  height: auto !important;\n  min-height: auto !important;\n  border-radius: 5px !important;\n  box-shadow: 1px 1px 5px #c6c6c6 !important;\n}\n\n.containerAdicionar {\n  margin-bottom: 1.5rem;\n}\n\n.areaAdicionar {\n  background: #fff;\n  border-radius: 5px;\n  box-shadow: 1px 1px 5px #c6c6c6;\n  padding: 0.75rem 0.9rem;\n}\n\n/* ✅ Indicadores de Status */\n.statusIndicator {\n  display: flex;\n  align-items: center;\n  padding: 0.5rem;\n  background: #e3f2fd;\n  border-radius: 4px;\n  margin-top: 0.5rem;\n  font-size: 0.85rem;\n  color: #1976d2;\n}\n\n.statusIndicatorError {\n  display: flex;\n  align-items: center;\n  padding: 0.5rem;\n  background: #ffebee;\n  border-radius: 4px;\n  margin-top: 0.5rem;\n  font-size: 0.85rem;\n  color: #d32f2f;\n}\n\n.statusIndicatorSuccess {\n  display: flex;\n  align-items: center;\n  padding: 0.5rem;\n  background: #e8f5e9;\n  border-radius: 4px;\n  margin-top: 0.5rem;\n  font-size: 0.85rem;\n  color: #2e7d32;\n}\n\n.statusText {\n  color: #1976d2;\n  font-weight: 500;\n}\n\n.statusTextError {\n  color: #d32f2f;\n  font-weight: 500;\n}\n\n.statusTextSuccess {\n  color: #2e7d32;\n  font-weight: 500;\n}\n\n/* Indicador Aguardando */\n.statusIndicatorAguardando {\n  display: flex;\n  align-items: center;\n  padding: 0.5rem;\n  background: #fff3e0;\n  border-radius: 4px;\n  margin-top: 0.5rem;\n  font-size: 0.85rem;\n  color: #f57c00;\n}\n\n.statusTextAguardando {\n  color: #f57c00;\n  font-weight: 500;\n}\n\n/* Estilos para a vista de Projeto */\n.containerProjeto {\n  margin-bottom: 1.5rem;\n}\n\n.containerProjeto:last-child {\n  margin-bottom: 0;\n}\n\n.cardProjeto {\n  background: #fff;\n  border-radius: 5px;\n  box-shadow: 1px 1px 5px #c6c6c6;\n  padding: 1.5rem;\n}\n\n.tituloProjeto {\n  color: #18316e;\n  font-size: 1rem;\n  font-weight: bold;\n  margin: 0 0 1.5rem 0;\n}\n\n.tabelaResumo {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 1rem;\n  margin-bottom: 1.5rem;\n}\n\n.tabelaResumo th,\n.tabelaResumo td {\n  padding: 0.75rem;\n  text-align: left;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.tabelaResumo th {\n  background: #f5f5f5;\n  font-weight: bold;\n  color: #18316e;\n  text-align: left;\n}\n\n.tabelaResumo td {\n  color: #333;\n}\n\n.tabelaResumo tbody tr:hover {\n  background: #f9f9f9;\n}\n\n.tabelaResumo .linhaTotal {\n  background: #f9f9f9;\n  font-weight: bold;\n  border-top: 2px solid #18316e;\n}\n\n.tabelaResumo .linhaTotal td {\n  color: #18316e;\n  font-size: 1rem;\n}\n\n\n/* Estilos para lista de créditos */\n.listaCreditos {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  margin-bottom: 1.5rem;\n}\n\n.itemCredito {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.75rem;\n  background: #f9f9f9;\n  border-radius: 4px;\n  border-left: 3px solid #18316e;\n}\n\n.labelCredito {\n  color: #333;\n  font-size: 0.95rem;\n}\n\n.valorCredito {\n  color: #18316e;\n  font-weight: 600;\n  font-size: 0.95rem;\n}\n\n.itemCreditoTotal {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem;\n  background: #e8f4f8;\n  border-radius: 4px;\n  border-left: 4px solid #18316e;\n  margin-top: 0.5rem;\n}\n\n.labelCreditoTotal {\n  color: #18316e;\n  font-weight: bold;\n  font-size: 1.1rem;\n}\n\n.valorCreditoTotal {\n  color: #18316e;\n  font-weight: bold;\n  font-size: 1.2rem;\n}\n\n.containerBtnProjeto {\n  display: flex;\n  gap: 0.5rem;\n  align-items: center;\n}\n\n/* Alerta de Projeto */\n.alertaProjeto {\n  display: flex;\n  align-items: stretch;\n  background: #fff3e0;\n  border-radius: 5px;\n  margin-bottom: 1.5rem;\n  position: relative;\n  overflow: hidden;\n}\n\n.alertaTraco {\n  width: 4px;\n  background: #f57c00;\n  flex-shrink: 0;\n}\n\n.alertaConteudo {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.75rem;\n  padding: 1rem;\n  flex: 1;\n}\n\n.alertaIcone {\n  color: #f57c00;\n  font-size: 1.5rem;\n  flex-shrink: 0;\n  margin-top: 0.125rem;\n}\n\n.alertaTexto {\n  color: #e65100;\n  font-size: 0.9rem;\n  line-height: 1.5;\n  flex: 1;\n}\n\n/* Tag de Projeto */\n.tagProjeto {\n  display: inline-block;\n  background: #18316e;\n  color: #fff;\n  font-size: 0.75rem;\n  font-weight: 600;\n  padding: 0.25rem 0.5rem;\n  border-radius: 4px;\n  margin-left: 0.5rem;\n  text-transform: uppercase;\n  vertical-align: middle;\n}\n\n.tagStatus {\n  color: #ffa726;\n  font-weight: 500;\n  text-transform: none;\n}\n\n.tagStatusAprovado {\n  color: #66bb6a;\n  font-weight: 500;\n  text-transform: none;\n}\n\n.tagStatusRejeitado {\n  color: #ef5350;\n  font-weight: 500;\n  text-transform: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"containerTitle": `styles_containerTitle__hS+x-`,
	"containerButtons": `styles_containerButtons__QBhuM`,
	"title": `styles_title__4Zbw+`,
	"containerVersao": `styles_containerVersao__Nn-iR`,
	"itemVersao": `styles_itemVersao__MLAKK`,
	"itemHeader": `styles_itemHeader__2LtRd`,
	"itemDate": `styles_itemDate__eJ4bg`,
	"containerBtn": `styles_containerBtn__yamoo`,
	"btnAnalisar": `styles_btnAnalisar__VbqS0`,
	"btnFechar": `styles_btnFechar__LDqEw`,
	"btnProjeto": `styles_btnProjeto__h3Kag`,
	"motoresContainer": `styles_motoresContainer__w+ZP4`,
	"motoresLeft": `styles_motoresLeft__8YMEZ`,
	"btnMotor": `styles_btnMotor__IWRfa`,
	"btnMotorRight": `styles_btnMotorRight__c0AGH`,
	"btnSemTema": `styles_btnSemTema__37skR`,
	"containerProgresso": `styles_containerProgresso__M3pPp`,
	"containerAdicionar": `styles_containerAdicionar__Zy0UI`,
	"areaAdicionar": `styles_areaAdicionar__458kS`,
	"statusIndicator": `styles_statusIndicator__XAqzh`,
	"statusIndicatorError": `styles_statusIndicatorError__q5H8D`,
	"statusIndicatorSuccess": `styles_statusIndicatorSuccess__RyjKP`,
	"statusText": `styles_statusText__9cu-K`,
	"statusTextError": `styles_statusTextError__leSRP`,
	"statusTextSuccess": `styles_statusTextSuccess__kYs4Q`,
	"statusIndicatorAguardando": `styles_statusIndicatorAguardando__nvT20`,
	"statusTextAguardando": `styles_statusTextAguardando__7Sl7M`,
	"containerProjeto": `styles_containerProjeto__AhjSP`,
	"cardProjeto": `styles_cardProjeto__YSsAG`,
	"tituloProjeto": `styles_tituloProjeto__9PHG7`,
	"tabelaResumo": `styles_tabelaResumo__JIv0c`,
	"linhaTotal": `styles_linhaTotal__NL3gu`,
	"listaCreditos": `styles_listaCreditos__wZN55`,
	"itemCredito": `styles_itemCredito__7gbMo`,
	"labelCredito": `styles_labelCredito__qPd1D`,
	"valorCredito": `styles_valorCredito__E+jJA`,
	"itemCreditoTotal": `styles_itemCreditoTotal__Urhmy`,
	"labelCreditoTotal": `styles_labelCreditoTotal__9Blr5`,
	"valorCreditoTotal": `styles_valorCreditoTotal__x5jiT`,
	"containerBtnProjeto": `styles_containerBtnProjeto__zLaRH`,
	"alertaProjeto": `styles_alertaProjeto__HzIT8`,
	"alertaTraco": `styles_alertaTraco__5ZSR6`,
	"alertaConteudo": `styles_alertaConteudo__DliJg`,
	"alertaIcone": `styles_alertaIcone__4T23L`,
	"alertaTexto": `styles_alertaTexto__5L0tK`,
	"tagProjeto": `styles_tagProjeto__Wch2h`,
	"tagStatus": `styles_tagStatus__cMbfY`,
	"tagStatusAprovado": `styles_tagStatusAprovado__4NKn5`,
	"tagStatusRejeitado": `styles_tagStatusRejeitado__ZWkF-`
};
export default ___CSS_LOADER_EXPORT___;
